const notificationsPath = '/notifications';
export const getNotifications = `${notificationsPath}`;
export const resendNotification = (id: number) => `${notificationsPath}/resend/${id}`;
export const sendNotification = `${notificationsPath}/new`;
export const sendGroupNotification = `${notificationsPath}/new/group`;

export const updateNotificationBatches = (id: number) => `${notificationsPath}/${id}/batches`;
export const updateNotificationScheduled = (id: number) => `${notificationsPath}/${id}/schedule`;
